import { Heading, Text } from '@zillow/constellation';
import type { Answers } from '../../../../../graphql/queries';
import { getAnswerForField } from '../../../../../utils/overview/overview-display';
import { FIELD_IDS } from '../../../../../constants/wizard';

interface Props {
  answers: Answers;
}

export function SmokingOverview({ answers }: Props) {
  const isSmoker = getAnswerForField({ fieldId: FIELD_IDS.IS_SMOKER, answers });

  return (
    <>
      {isSmoker && (
        <>
          <Heading level={6} marginY="xs">
            Does anyone in the household smoke?
          </Heading>
          <Text>{isSmoker}</Text>
        </>
      )}
    </>
  );
}
